import CardLogo from './CardLogo';

export default CardLogo;
